import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import {
  User,
  BookBookmark,
  HandsPraying,
  GearSix,
  SignOut,
  ShieldCheck,
  Heart,
  BookOpen,
  UsersThree,
  Bell,
  ArrowRight,
} from "@phosphor-icons/react";

const menuItems = [
  { icon: BookBookmark, label: "My Journal", to: "/journal", desc: "Saved prayers & verses" },
  { icon: HandsPraying, label: "Prayer History", to: "/journal", desc: "Past prayer journeys" },
  { icon: BookOpen, label: "Learning Progress", to: "/learn", desc: "Continue your growth" },
  { icon: UsersThree, label: "My Groups", to: "/community", desc: "Your communities" },
  { icon: Heart, label: "Giving History", to: "/give", desc: "Your donations" },
  { icon: Bell, label: "Notifications", to: "/profile", desc: "Manage alerts" },
  { icon: GearSix, label: "Settings", to: "/profile", desc: "Preferences & account" },
];

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="px-5 md:px-8 py-4 max-w-lg mx-auto" data-testid="profile-page">
      {/* User Card */}
      <div className="glass-card-strong p-6 mb-6 text-center" data-testid="profile-card">
        <div className="w-16 h-16 rounded-full bg-[#EDE6DC] flex items-center justify-center mx-auto mb-3">
          <User size={28} weight="duotone" className="text-[#8B7355]" />
        </div>
        <h2 className="font-heading text-xl text-[#2D1B0E] font-medium">{user?.name || "User"}</h2>
        <p className="text-[#8B7355] font-body text-sm">{user?.email}</p>
        {user?.role === "admin" && (
          <Link to="/admin" className="inline-flex items-center gap-1 mt-2 text-[#C4A265] text-xs font-body">
            <ShieldCheck size={12} weight="duotone" /> Admin Dashboard
          </Link>
        )}
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        {[
          { label: "Streak", value: "7 days" },
          { label: "Prayers", value: "12" },
          { label: "Lessons", value: "4" },
        ].map((s, i) => (
          <div key={i} className="glass-card p-3 text-center">
            <p className="font-heading text-lg text-[#2D1B0E] font-medium">{s.value}</p>
            <p className="font-body text-[10px] text-[#8B7355]">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Menu Items */}
      <div className="space-y-2 mb-6">
        {menuItems.map((item) => (
          <Link key={item.label} to={item.to} data-testid={`profile-${item.label.toLowerCase().replace(/ /g, "-")}`}>
            <div className="glass-card p-4 flex items-center gap-3 transition-all hover:-translate-y-0.5">
              <div className="w-9 h-9 rounded-xl bg-[#EDE6DC] flex items-center justify-center flex-shrink-0">
                <item.icon size={18} weight="duotone" className="text-[#5C4033]" />
              </div>
              <div className="flex-1">
                <p className="font-body text-sm font-medium text-[#2D1B0E]">{item.label}</p>
                <p className="font-body text-[10px] text-[#8B7355]">{item.desc}</p>
              </div>
              <ArrowRight size={14} className="text-[#B8A088]" />
            </div>
          </Link>
        ))}
      </div>

      {/* Logout */}
      <button onClick={handleLogout} data-testid="logout-btn"
        className="w-full py-3 rounded-xl glass-card text-red-400 font-body text-sm flex items-center justify-center gap-2 hover:bg-red-50/50 transition-all">
        <SignOut size={16} /> Sign Out
      </button>
    </div>
  );
}
